<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                labTestForm: () => import('../forms/LabTestForm'),
                sampleSetForm: () => import('../forms/SampleSetForm'),
                fields: [
                    { type: 'autocomplete', text: 'Sample Set', value: 'sampleSetId', rules: [v => !!v || 'Sample Set is required'], isRequired: true, form: () => import('./SampleSetForm'), apiMethod: 'SampleSets', claim: 'SampleSets' },
                    { type: 'autocomplete', text: 'Lab Test', value: 'labTestId', rules: [v => !!v || 'Lab Test is required'], isRequired: true, form: () => import('./LabTestForm'), apiMethod: 'LabTests', claim: 'LabTests' },
                ],
                apiMethod: 'SampleSetTests',
                formTitle: 'Sample Set Test',
            }
        },
    };
</script>
